import md5 from './md5'
import base64 from './base64'

const Utils = {
  // phoneReg: /^(13[0-9]|14[5|7]|15[0|1|2|3|5|6|7|8|9]|18[0|1|2|3|5|6|7|8|9]|17[0|1|2|3|5|6|7|8|9])\d{8}$/,
  phoneReg: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
  nameReg: /^[\u4E00-\u9FA5]{2,4}$/,
  // 必须包含字母数字
  pwdReg: /[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/,

  test (reg, str) {
    if (reg.test(str)) {
      return true
    } else {
      return false
    }
  },

  // 验证手机
  testPhone (str) {
    return this.test(this.phoneReg, str)
  },

  // 验证姓名
  testName (str) {
    return this.test(this.nameReg, str)
  },

  // 验证密码
  testPwd (str) {
    return this.test(this.pwdReg, str)
  },

  // 获取发送验证码的验证key
  getCodeKey () {
    let curDate = new Date()
      , year = curDate.getFullYear()
      , month = curDate.getMonth() + 1
      , day = curDate.getDate()
      , fineDate = '' + year + (month > 9 ? month : '0' + month) + (day > 9 ? day : '0' + day)

    console.log(fineDate, md5.str_md5(fineDate), base64.base64encode(md5.str_md5(fineDate)))
    return base64.base64encode(md5.str_md5(fineDate))
  }

  //获取随机数
  , randomString (len) {
    var len = len || 32
    var $chars = 'ABCDEFGHIJKMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var maxPos = $chars.length
    var pwd = ''
    for (let i = 0; i < len; i++) {
      pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
    }
    return pwd
  }

  /**
   * 去掉字符串空格
   * @param str 字符串
   * @returns {*}
   */
  , trim (str) {
    if (typeof str === 'string') {
      return str.replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, '')
    }
    return str
  }

  /**
   * 深度克隆对象
   * @param Obj
   */
  , deepClone (obj) {
    return JSON.parse(JSON.stringify(obj))
  }

  /**
   * 获取query内容
   * @param name      要筛选的名
   * @param queryStr  要筛选的内容
   * @returns {*}
   * @constructor
   */
  , getQueryString (queryStr, name) {
    if (queryStr == undefined) {
      return null
    }
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var bs = decodeURI(queryStr)
    bs = base64.base64decode(bs)
    bs = decodeURI(bs)
    var link = bs
    var r = link.match(reg)
    if (r != null) return unescape(r[2])
    return null
  }
}

export default Utils



// WEBPACK FOOTER //
// ./src/utils/utils.js